export const SelectIconStyle = {
  selectedIcon: {
    style: {
      overflow: 'hidden',
      maxHeight: 50,
      fontSize: 12,
    },
  },
  box: {
    style: {
      display: 'flex',
      cursor: 'pointer',
    },
  },
  icon: {
    style: {
      marginLeft: '10px',
    },
    sx: {
      color: 'text.secondary',
    },
  },
  dialogTitle: {
    sx: {
      backgroundColor: 'primary.main',
      color: 'white',
    },
    style: {
      display: 'flex',
    },
  },
  close: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  dialogContent: {
    minWidth: '600px',
    height: '380px',
    overflow: 'overlay',
  },
  scroll: {
    '&::-webkit-scrollbar': {
      width: '20px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#949494',
      borderRadius: '20px',
      border: '6px solid transparent',
      backgroundClip: 'content-box',
    },
  },
  errorBox: {
    sx: {
      my: 3,
    },
  },
} as const;
